export default "__VITE_ASSET__BS_Ols8q__"